<div class="alert-comp">
  <h1 mat-dialog-title *ngIf="!data.subtitle">{{ data }}</h1>
  <h1 mat-dialog-title *ngIf="data.title">{{ data.title }}</h1>
  <mat-dialog-content *ngIf="data.subtitle">{{ data.subtitle }}</mat-dialog-content>
  <div mat-dialog-actions class="buttons">
    <button mat-button (click)="onYesClick()">Yes</button>
    <button mat-button (click)="onNoClick()" cdkFocusInitial>No</button>
  </div>
</div>
